import type {ResponseFormat, Message, MessageFromApi} from '@/client/mentor/MessagesClient'
import {defaultApi} from '@/axios'
import {parseMessage} from '@/client/mentor/MessagesClient'

export interface MessageRequest {
  companyId: number
  prompt: string
  preferredFormat?: ResponseFormat | null
  conversationId?: string | null
}

export class ChatClient {
  async sendMessage(data: MessageRequest, signal?: AbortSignal): Promise<Message> {
    return defaultApi
      .post<MessageFromApi>('/api/mentor/chat/message', data, {customData: {isExcludedFromLoadingBar: true}, signal})
      .then((res) => parseMessage(res.data))
  }
}

const chatClient = new ChatClient()

export default chatClient
